/* Type-to-filter for the country/currency picker.
   The list holds every market Shopify serves, which is a lot of scrolling; this filters it on
   the country name, the currency code and the ISO code.

   Two things the theme's own LocalizationForm forces:
   - it closes the panel on the toggle button's focusout unless the element taking focus carries
     .disclosure-list__option, so the input carries that class (see country-selector.liquid);
   - the list sits inside the localization <form>, so Enter would submit it with the country
     unchanged. Enter picks the first match instead. */
(() => {
  if (window.__ccCountrySearch) return; // the snippet renders in the footer and the menu drawer
  window.__ccCountrySearch = true;

  const norm = (s) =>
    (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '') // so "oster" finds "Østerrig" and "espana" finds "España"
      .replace(/ø/g, 'o')
      .replace(/æ/g, 'ae')
      .replace(/å/g, 'a');

  const setup = (input) => {
    const list = input.closest('.disclosure-list');
    if (!list || input.dataset.ccReady) return;
    input.dataset.ccReady = '1';

    const rows = [...list.querySelectorAll('.disclosure-list__item')].map((li) => ({
      li,
      text: norm(li.textContent) + ' ' + norm(li.querySelector('[data-value]')?.dataset.value),
    }));
    const none = list.querySelector('[data-cc-country-none]');

    const filter = () => {
      const q = norm(input.value).trim();
      let hits = 0;
      rows.forEach((r) => {
        const show = !q || r.text.includes(q);
        r.li.hidden = !show;
        if (show) hits += 1;
      });
      if (none) none.hidden = hits > 0;
      list.scrollTop = 0;
    };

    input.addEventListener('input', filter);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault(); // never let it submit the localization form as-is
        rows.find((r) => !r.li.hidden)?.li.querySelector('[data-disclosure-option]')?.click();
      } else if (event.key === 'Escape' && input.value) {
        event.stopPropagation(); // first Escape clears, a second one closes the panel
        input.value = '';
        filter();
      }
    });

    // opening the picker puts the cursor in the field and starts from the whole list again
    const form = input.closest('localization-form');
    if (form) {
      new MutationObserver(() => {
        if (!form.hasAttribute('open')) return;
        input.value = '';
        filter();
        window.setTimeout(() => input.focus({ preventScroll: true }), 30);
      }).observe(form, { attributes: true, attributeFilter: ['open'] });
    }
  };

  const boot = () => document.querySelectorAll('[data-cc-country-search]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
